import { CAMPAIGN_DELIVERABILITY_STATUS_ENUM } from '../../../../shared/constants'

export const steps = [
  {
    label: 'Digital proofs',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DIGITAL_PROOFS,
  },
  {
    label: 'Printing',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.PRINTING,
  },

  {
    label: 'Out for delivery',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_DELIVERY,
  },
  {
    label: 'Received in local office',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.RECEIVED_IN_LOCAL_OFFICE,
  },
  {
    label: 'Out for postage',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.OUT_FOR_POSTAGE,
  },
  {
    label: 'Distributed',
    value: CAMPAIGN_DELIVERABILITY_STATUS_ENUM.DISTRIBUTED,
  },
]



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignTimeline/options.js